import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-compliance-check-expired',
  imports: [],
  templateUrl: './compliance-check-expired.component.html',
})
export class ComplianceCheckExpiredComponent {
  clientTeamEmailAddress = input.required<string>();
}
